/** Progress shown only on the entry step (`primary_goal`). */
export const FIRST_STEP_PROGRESS = 5;

export const ENTRY_STEP_ID = 'primary_goal';

export const FINDER_ENTRY_PATH = '/credit-cards/cardfinder';

export const RECOMMENDATIONS_PATH = '/credit-cards/cardfinder/recommendations';

/** Marks a results visit that came from finishing the funnel; removed once results render. */
export const FUNNEL_ENTRY_PARAM = 'entry';
export const FUNNEL_ENTRY_VALUE = 'funnel';

/** Terminal marker: reaching this ends the funnel and routes to the recommendations page. */
export const RECOMMENDATIONS = 'recommendations' as const;
export type RecommendationsTerminal = typeof RECOMMENDATIONS;
export const CARDFINDER_FLOW_NAME = 'cardfinder';
